<template>
  <div class="container adlcj">
    <div class="row twoColumn itemCenter">
      <div class="col twoColumnText">
        <p>
          L’ADLCJ, Association pour le Développement de la Langue et de la
          Culture Japonaises, a été créée en 1988 dans le but de donner un
          enseignement aux ressortissants japonais et bi-nationaux.
        </p>
        <p>
          L’école complémentaire pour l’enseignement du japonais à Lyon suit les
          programmes scolaires définis par le Ministère de l'Éducation, de la
          Culture, des Sports, des Sciences et de la Technologie japonais.
          L’enseignement proposé par l’école couvre les programmes de japonais
          et de mathématiques, de la maternelle au lycée.
        </p>
        <p>
          L’école est tenue et gérée par un corps administratif bénévole. Les
          activités proposées tout au long de l’année sont possibles grâce aux
          aides des parents d’élèves.
        </p>
        <p>
          En plus de professeurs expérimentés, les enfants sont accompagnés par
          des assistants bénévoles, principalement des étudiants intéressés par
          l’éducation bi-culturelle.
        </p>
        <p>
          L’ADLCJ participe beaucoup à la vie municipale, proposant des ateliers
          culturels aux centres sociaux ou des animations lors de divers
          évènements festifs. Retrouvez toutes les dernières actualités de l'ADLCJ sur notre
          <a
            href="https://www.facebook.com/Adlcjlyonhoshujyugyoko/"
            class="facebookLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            page Facebook</a
          >.
        </p>
      </div>
    </div>

    <section class="row boxShadow">
      <div class="col colImageLeft">
        <img
          src="../assets/image/photos/remiseduprix.jpg"
          alt="Remise du prix du Ministre des Affaires étrangères à Madame MARRET, la présidente de l'ADLCJ"
        />
      </div>
      <div class="col">
        <h2>
          Remise du prix du Ministre des Affaires étrangères à Madame MARRET
          Hisano
        </h2>
        <p>
          Le 15 janvier 2020, la présidente de l'association Madame MARRET
          Hisano a reçu le Prix du Ministre des Affaires étrangères.
        </p>
        <p>
          Ce prix lui a été décerné en reconnaissance de sa contribution à la
          compréhension mutuelle et au développement de l’amitié entre le Japon
          et la France.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AdlcjFR",
};
</script>

<style lang="scss" scoped>
.boxShadow {
  @media (max-width: 767px) {
    flex-direction: column;

    .col {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
    }

    .colImageLeft img {
      width: 100%;
      height: auto;
    }
  }
}

.facebookLink {
  font-weight: 600;
  color: $linkColor;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
